(() => {
  const sections = document.querySelectorAll('[data-rassegna-stampa]');

  sections.forEach((section) => {
    const articleList = section.querySelector('[data-rassegna-articles]');
    const pagination = section.querySelector('[data-rassegna-pagination]');
    const filterButtons = Array.from(section.querySelectorAll('[data-year-filter]'));

    if (!articleList || !pagination) {
      return;
    }

    const articleItems = Array.from(articleList.querySelectorAll('.rassegna-stampa__article'));
    const pageSize = Number.parseInt(section.dataset.pageSize, 10) || 6;
    let activeYear = 'all';
    let currentPage = 1;

    const getFilteredItems = () =>
      articleItems.filter((item) => activeYear === 'all' || item.dataset.articleYear === activeYear);

    const createButton = ({ label, page, className = '', disabled = false, current = false }) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `rassegna-stampa__pagination-btn ${className}`.trim();
      button.textContent = label;
      button.disabled = disabled;

      if (current) {
        button.classList.add('is-current');
        button.setAttribute('aria-current', 'page');
      } else if (!disabled) {
        button.dataset.page = String(page);
      } else {
        button.classList.add('is-disabled');
      }

      return button;
    };

    const createEllipsis = () => {
      const ellipsis = document.createElement('span');
      ellipsis.className = 'rassegna-stampa__pagination-ellipsis';
      ellipsis.textContent = '...';
      return ellipsis;
    };

    const getVisiblePages = (totalPages, activePage) => {
      if (totalPages <= 5) {
        return Array.from({ length: totalPages }, (_, index) => index + 1);
      }

      const pages = [1];
      const start = Math.max(2, activePage - 1);
      const end = Math.min(totalPages - 1, activePage + 1);

      if (start > 2) {
        pages.push('ellipsis-start');
      }

      for (let page = start; page <= end; page += 1) {
        pages.push(page);
      }

      if (end < totalPages - 1) {
        pages.push('ellipsis-end');
      }

      pages.push(totalPages);
      return pages;
    };

    const renderPagination = (totalPages) => {
      pagination.innerHTML = '';

      if (totalPages <= 1) {
        pagination.hidden = true;
        return;
      }

      pagination.hidden = false;

      const list = document.createElement('ul');
      list.className = 'rassegna-stampa__pagination-list list-unstyled';

      const prevItem = document.createElement('li');
      prevItem.appendChild(
        createButton({
          label: '<',
          page: currentPage - 1,
          className: 'is-prev',
          disabled: currentPage === 1
        })
      );
      list.appendChild(prevItem);

      getVisiblePages(totalPages, currentPage).forEach((page) => {
        const pageItem = document.createElement('li');

        if (typeof page === 'string') {
          pageItem.appendChild(createEllipsis());
        } else {
          pageItem.appendChild(
            createButton({
              label: String(page),
              page,
              current: page === currentPage
            })
          );
        }

        list.appendChild(pageItem);
      });

      const nextItem = document.createElement('li');
      nextItem.appendChild(
        createButton({
          label: '>',
          page: currentPage + 1,
          className: 'is-next',
          disabled: currentPage === totalPages
        })
      );
      list.appendChild(nextItem);

      pagination.appendChild(list);
    };

    const render = () => {
      const filteredItems = getFilteredItems();
      const totalPages = Math.max(1, Math.ceil(filteredItems.length / pageSize));
      const safeCurrentPage = Math.min(currentPage, totalPages);
      const startIndex = (safeCurrentPage - 1) * pageSize;
      const endIndex = startIndex + pageSize;

      articleItems.forEach((item) => {
        item.hidden = true;
      });

      filteredItems.slice(startIndex, endIndex).forEach((item) => {
        item.hidden = false;
      });

      currentPage = safeCurrentPage;
      renderPagination(totalPages);
    };

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeYear = button.dataset.yearFilter || 'all';
        currentPage = 1;

        filterButtons.forEach((btn) => btn.classList.remove('is-active'));
        button.classList.add('is-active');

        render();
      });
    });

    pagination.addEventListener('click', (event) => {
      const button = event.target.closest('button[data-page]');
      if (!button) {
        return;
      }

      const nextPage = Number.parseInt(button.dataset.page, 10);
      if (Number.isNaN(nextPage) || nextPage < 1) {
        return;
      }

      currentPage = nextPage;
      render();
    });

    render();
  });
})();
